import React from 'react';

import { styled } from '@mui/material/styles';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import Box from '@mui/material/Box';

import withReadModeField from 'components/shared/CRUD/components/InnerPage/components/withReadModeField';

import { CodeField, NameField } from '../FormFields';
import SurchargeMaintenanceDetailsTable from './SurchargesMaintenanceDetailsTable';
import {
  GridContainer,
  GridCompact6
} from 'components/shared/Grid/Grid.components';

const PREFIX = 'SurchargesMaintenanceFormFields';

const classes = {
  root: `${PREFIX}-root`
};

const StyledBox = styled(Box)(() => ({
  [`&.${classes.root}`]: {
    flexDirection: 'column',
    flex: 1
  }
}));

interface Props {
  setDeletedIds: React.Dispatch<React.SetStateAction<number[]>>;
}

const CodeFieldWithReadMode = withReadModeField(CodeField);
const NameFieldWithReadMode = withReadModeField(NameField);

const SurchargesMaintenanceFormFields: React.FC<Props> = ({
  setDeletedIds
}) => {
  const { control } = useFormContext();
  const { t } = useTranslation('common');

  return (
    <StyledBox display="flex" className={classes.root}>
      <Box mb={2.5} sx={{ width: '100%' }}>
        <GridContainer mb={2.5}>
          <GridCompact6>
            <CodeFieldWithReadMode
              name="code"
              label={t('surchargesMaintenance.grid.code')}
            />
          </GridCompact6>

          <GridCompact6>
            <NameFieldWithReadMode
              control={control}
              name="name"
              label={t('surchargesMaintenance.grid.name')}
            />
          </GridCompact6>
        </GridContainer>
      </Box>
      <SurchargeMaintenanceDetailsTable setDeletedIds={setDeletedIds} />
    </StyledBox>
  );
};

export default SurchargesMaintenanceFormFields;
